<div *ngIf="isLoadingWithDelay$ | async;">

    <mat-progress-bar mode="indeterminate"
                      [style.width]="width + '%'"
                      style="position:absolute;"></mat-progress-bar>

</div>
